import React from 'react';
import './KeyboardHelp.css';

export const KeyboardHelp = ({ onClose }) => {
  const shortcuts = [
    { key: '←/→', description: 'Navigate between cards' },
    { key: 'Space / F', description: 'Flip card' },
    { key: 'M', description: 'Mark card as memorized' },
    { key: 'B', description: 'Bookmark/favorite card' },
    { key: 'S', description: 'Toggle search mode' },
    { key: 'R', description: 'Shuffle/reset card order' },
    { key: '?', description: 'Open menu' },
    { key: 'Esc', description: 'Close modals or exit search' },
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="keyboard-help" onClick={(e) => e.stopPropagation()}>
        <div className="keyboard-help-header">
          <h2>Keyboard Shortcuts</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="keyboard-help-content">
          <p className="help-intro">
            Use these keyboard shortcuts to navigate faster:
          </p>
          <div className="shortcuts-list">
            {shortcuts.map((shortcut, index) => (
              <div key={index} className="shortcut-item">
                <kbd className="shortcut-key">{shortcut.key}</kbd>
                <span className="shortcut-description">{shortcut.description}</span>
              </div>
            ))}
          </div>
          <div className="help-note">
            Shortcuts work when not typing in an input field
          </div>
        </div>
      </div>
    </div>
  );
};
